/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Here mentioned users feature request structure
 */
const API = {
  GET_USER_LIST: {
    path: '/organizations/:organizationId/users?:query',
    method: 'GET',
  },
  GET_SELECTED_USER_LIST: {
    path: '/organizations/:organizationId/users?:query',
    method: 'GET',
  },
  GET_ROLES: {
    path: '/organizations/:organizationId/roles',
    method: 'GET',
  },
  GET_HOTELS: {
    path: '/organizations/:organizationId/users/:userId/hotels?:query',
    method: 'GET',
  },
  GET_ALL_HOTELS: {
    path: '/organizations/:organizationId/hotels?:query',
    method: 'GET',
  },
  POST_USERS: {
    path: '/organizations/:organizationId/users',
    method: 'POST',
  },
  POST_USERS_ADMIN: {
    path: '/organizations/:organizationId/users/admin',
    method: 'POST',
  },
  POST_USERS_GENERAL: {
    path: '/organizations/:organizationId/users/general',
    method: 'POST',
  },
  PATCH_USER: {
    path: '/organizations/:organizationId/users/:userId',
    method: 'PATCH',
  },
  PATCH_ROLE: {
    path: '/organizations/:organizationId/users/:userId/assign-roles',
    method: 'PATCH',
  },
  PATCH_HOTEL: {
    path: '/organizations/:organizationId/users/:userId/hotels',
    method: 'PATCH',
  },
  DELETE_USER: {
    path: '/organizations/:organizationId/users/:userId',
    method: 'DELETE',
  },
  GET_USER_BY_ID: {
    path: '/organizations/:organizationId/users/:userId',
    method: 'GET',
  },
  POST_CHANGE_PASSWORD: {
    path: '/organizations/:organizationId/users/:userId/update-password',
    method: 'POST',
  },
  GET_LANDING_PAGE: {
    path: '/organizations/:organizationId/users/:userId/configurations/landing-page',
    method: 'GET',
  },
  POST_LANDING_PAGE: {
    path: '/organizations/:organizationId/users/:userId/configurations/landing-page',
    method: 'POST',
  },
  GET_STAY_DATE_PRESET: {
    path: '/organizations/:organizationId/users/:userId/configurations',
    method: 'GET',
  },
  POST_STAY_DATE_PRESET: {
    path: '/organizations/:organizationId/users/:userId/configurations/custom-date-range',
    method: 'POST',
  },
  DELETE_STAY_DATE_PRESET: {
    path: '/organizations/:organizationId/users/:userId/configurations/custom-date-range/:customDateRangeId',
    method: 'DELETE',
  },
  POST_HOTEL_METADATA: {
    path: '/organizations/:organizationId/users/:userId/hotel-metadata',
    method: 'POST',
  },
  GET_CURRENCY_DATA: {
    path: '/organizations/:organizationId/currency?:query',
    method: 'GET',
  },
  POST_PHONE_NUMBER: {
    path: '/organizations/:organizationId/users/:userId/enable-appless-query',
    method: 'POST',
  },
  POST_OTP: {
    path: '/organizations/:organizationId/users/:userId/verify-otp',
    method: 'POST',
  },
  PATCH_USER_CONFIGURATION: {
    path: '/organizations/:organizationId/users/:userId/configurations',
    method: 'PATCH',
  },
};
//
export default API;
